import * as React from "react";
import numeral from "numeral";
import styled from "styled-components";
import { useCallback } from "react";
import { useField } from "formik";
import { Button, Input } from "components/bootstrap";
import { MAX_LOGO_SIZE } from "report/Constants";
import { Icon, InputDescription, Dropzone } from "components/common";
const DropzoneInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
const LogoWrapper = styled.div`
  position: relative;
  border: 1px #e3e3e3 solid;
  display: inline-block;
`;
const Logo = styled.img`
  max-width: 130px;
  max-height: 130px;
`;
const RemoveButton = styled(Button)`
  position: absolute;
  top: 5px;
  right: 5px;
`;
const ReportLogoEdit = () => {
  const [, { value, error }, { setValue }] = useField("logo");
  const updateReportLogo = useCallback(
    (file) => {
      if (!file) {
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        setValue(reader.result);
      };
      reader.readAsDataURL(file);
    },
    [setValue]
  );
  return /* @__PURE__ */ React.createElement(Input, { id: "report-logo-edit", label: "Logo" }, /* @__PURE__ */ React.createElement("div", null, value && /* @__PURE__ */ React.createElement(LogoWrapper, null, /* @__PURE__ */ React.createElement(Logo, { src: value, alt: "report-logo" }), /* @__PURE__ */ React.createElement(RemoveButton, { bsSize: "xsmall", bsStyle: "danger", title: "Remove logo", onClick: () => setValue(void 0) }, /* @__PURE__ */ React.createElement(Icon, { name: "close" }))), !value && /* @__PURE__ */ React.createElement(
    Dropzone,
    {
      onDrop: (files) => updateReportLogo(files[0]),
      onReject: () => {
      },
      accept: ["image/png", "image/jpeg"],
      "data-testid": "upload-dropzone",
      inputProps: {
        placeholder: "Drag a logo here or click to select file"
      },
      maxSize: MAX_LOGO_SIZE,
      loading: false
    },
    /* @__PURE__ */ React.createElement(DropzoneInner, null, /* @__PURE__ */ React.createElement(Dropzone.Accept, null, /* @__PURE__ */ React.createElement(Icon, { name: "image", type: "regular", size: "2x" })), /* @__PURE__ */ React.createElement(Dropzone.Reject, null, /* @__PURE__ */ React.createElement(Icon, { name: "warning", size: "2x" })), /* @__PURE__ */ React.createElement(Dropzone.Idle, null, /* @__PURE__ */ React.createElement(Icon, { name: "image", type: "regular", size: "2x" })), /* @__PURE__ */ React.createElement("div", null, "Drag a logo here or click to select file"))
  )), /* @__PURE__ */ React.createElement(
    InputDescription,
    {
      error,
      help: /* @__PURE__ */ React.createElement(React.Fragment, null, "Choose an image to use as a logo in the report's cover page. The image must be in JPEG or PNG formats and cannot exceed ", numeral(MAX_LOGO_SIZE).format("0 b"), ".")
    }
  ));
};
export default ReportLogoEdit;
